import React from "react";

const sample_content_data = {
  data: {
    content: [
      [
        {
          data: {
            title: "주소",
            value: "서울시 강남구 역삼동 101-1",
            unit: "",
            second_value: "",
            second_unit: "",
          },
          use_tooltip: {
            title: false,
            value: false,
            second_value: false,
          },
          use_toggle: false,
          tooltip: {
            title: [],
            value: [],
            second_value: [],
          },
          style: "default",
        },
        {
          data: {
            title: "토지 면적",
            value: "1,070",
            unit: "\u00A0평",
            second_value: "",
            second_unit: "",
          },
          use_tooltip: {
            title: false,
            value: false,
            second_value: false,
          },
          use_toggle: false,
          tooltip: {
            title: [],
            value: [],
            second_value: [],
          },
          style: "default",
        },
        {
          data: {
            title: "최대 건폐율",
            value: "60",
            unit: "\u00A0%",
            second_value: "",
            second_unit: "",
          },
          use_tooltip: {
            title: false,
            value: false,
            second_value: false,
          },
          use_toggle: false,
          tooltip: {
            title: [],
            value: [],
            second_value: [],
          },
          style: "default",
        },
        {
          data: {
            title: "용도지역",
            value: "일반상업지역",
            unit: "",
            second_value: "",
            second_unit: "",
          },
          use_tooltip: {
            title: false,
            value: false,
            second_value: false,
          },
          use_toggle: false,
          tooltip: {
            title: [],
            value: [],
            second_value: [],
          },
          style: "default",
        },
        {
          data: {
            title: "최근 실거래가",
            value: "2,000억",
            unit: "\u00A0원",
            second_value: "",
            second_unit: "",
          },
          use_tooltip: {
            title: false,
            value: false,
            second_value: false,
          },
          use_toggle: false,
          tooltip: {
            title: [],
            value: [],
            second_value: [],
          },
          style: "default",
        },
        {
          data: {
            title: "임대료(명목 NOC)",
            value: "20만",
            unit: "\u00A0원/전용평/월",
            second_value: "",
            second_unit: "",
          },
          use_tooltip: {
            title: false,
            value: false,
            second_value: false,
          },
          use_toggle: false,
          tooltip: {
            title: [],
            value: [],
            second_value: [],
          },
          style: "default",
        },
      ],
      [
        {
          data: {
            title: "적용 건폐율",
            value: "58",
            unit: "\u00A0%",
            second_value: "",
            second_unit: "",
          },
          use_tooltip: {
            title: false,
            value: true,
            second_value: false,
          },
          use_toggle: false,
          tooltip: {
            title: [],
            value: ["무언가 기준"],
            second_value: [],
          },
          style: "default",
        },
        {
          data: {
            title: "적용 용적률",
            value: "754",
            unit: "\u00A0%",
            second_value: "",
            second_unit: "",
          },
          use_tooltip: {
            title: false,
            value: true,
            second_value: false,
          },
          use_toggle: false,
          tooltip: {
            title: [],
            value: ["무언가 기준"],
            second_value: [],
          },
          style: "default",
        },
        {
          data: {
            title: "적용 전용률",
            value: "54",
            unit: "\u00A0%",
            second_value: "",
            second_unit: "",
          },
          use_tooltip: {
            title: false,
            value: true,
            second_value: false,
          },
          use_toggle: false,
          tooltip: {
            title: [],
            value: ["무언가 기준"],
            second_value: [],
          },
          style: "default",
        },
        {
          data: {
            title: "연면적",
            value: "4,949",
            unit: "\u00A0평",
            second_value: "",
            second_unit: "",
          },
          use_tooltip: {
            title: false,
            value: true,
            second_value: false,
          },
          use_toggle: false,
          tooltip: {
            title: [],
            value: ["무언가 기준"],
            second_value: [],
          },
          style: "default",
        },
      ],
      [
        {
          data: {
            title: "구매 비용",
            value: "3,200억",
            unit: "\u00A0원",
            second_value: "",
            second_unit: "",
          },
          use_tooltip: {
            title: false,
            value: false,
            second_value: false,
          },
          use_toggle: false,
          tooltip: {
            title: [],
            value: [],
            second_value: [],
          },
          style: "default",
        },
        {
          data: {
            title: "구매 대금",
            value: "3,200억",
            unit: "\u00A0원",
            second_value: "",
            second_unit: "",
          },
          use_tooltip: {
            title: false,
            value: false,
            second_value: false,
          },
          use_toggle: false,
          tooltip: {
            title: [],
            value: [],
            second_value: [],
          },
          style: "detail",
        },
        {
          data: {
            title: "취득세 등 부대비용",
            value: "18,700백만",
            unit: "\u00A0원",
            second_value: "5.5",
            second_unit: "\u00A0%",
          },
          use_tooltip: {
            title: false,
            value: false,
            second_value: false,
          },
          use_toggle: false,
          tooltip: {
            title: [],
            value: [],
            second_value: [],
          },
          style: "detail",
        },
        {
          data: {
            title: "매입보수",
            value: "18,700백만",
            unit: "\u00A0원",
            second_value: "1.0",
            second_unit: "\u00A0%",
          },
          use_tooltip: {
            title: false,
            value: false,
            second_value: false,
          },
          use_toggle: false,
          tooltip: {
            title: [],
            value: [],
            second_value: [],
          },
          style: "detail",
        },
        {
          data: {
            title: "중개보수",
            value: "2,040백만",
            unit: "\u00A0원",
            second_value: "0.6",
            second_unit: "\u00A0%",
          },
          use_tooltip: {
            title: false,
            value: false,
            second_value: false,
          },
          use_toggle: false,
          tooltip: {
            title: [],
            value: [],
            second_value: [],
          },
          style: "detail",
        },
        {
          data: {
            title: "건설기간보유세",
            value: "2,400백만",
            unit: "\u00A0원",
            second_value: "1,200백만",
            second_unit: "\u00A0원/년",
          },
          use_tooltip: {
            title: false,
            value: false,
            second_value: false,
          },
          use_toggle: false,
          tooltip: {
            title: [],
            value: [],
            second_value: [],
          },
          style: "detail",
        },
        {
          data: {
            title: "AM/PM보수",
            value: "2,400백만",
            unit: "\u00A0원",
            second_value: "1,200백만",
            second_unit: "\u00A0원/년",
          },
          use_tooltip: {
            title: false,
            value: false,
            second_value: false,
          },
          use_toggle: false,
          tooltip: {
            title: [],
            value: [],
            second_value: [],
          },
          style: "detail",
        },
        {
          data: {
            title: "예비비",
            value: "2,000백만",
            unit: "\u00A0원",
            second_value: "1,200백만",
            second_unit: "\u00A0원/년",
          },
          use_tooltip: {
            title: false,
            value: false,
            second_value: false,
          },
          use_toggle: false,
          tooltip: {
            title: [],
            value: [],
            second_value: [],
          },
          style: "detail",
        },
      ],
      [
        {
          data: {
            title: "건축 비용",
            value: "760억",
            unit: "\u00A0원",
            second_value: "",
            second_unit: "",
          },
          use_tooltip: {
            title: false,
            value: false,
            second_value: false,
          },
          use_toggle: false,
          tooltip: {
            title: [],
            value: [],
            second_value: [],
          },
          style: "default",
        },
      ],
      [
        {
          data: {
            title: "대출 이자",
            value: "5.5",
            unit: "\u00A0%",
            second_value: "",
            second_unit: "",
          },
          use_tooltip: {
            title: false,
            value: false,
            second_value: false,
          },
          use_toggle: false,
          tooltip: {
            title: [],
            value: [],
            second_value: [],
          },
          style: "default",
        },
      ],
      [
        {
          data: {
            title: "임대료",
            value: "28만",
            unit: "\u00A0원/전용평/월",
            second_value: "",
            second_unit: "",
          },
          use_tooltip: {
            title: false,
            value: false,
            second_value: false,
          },
          use_toggle: false,
          tooltip: {
            title: [],
            value: [],
            second_value: [],
          },
          style: "default",
        },
      ],
    ],
    footer: [
      {
        data: {
          title: "사업비",
          value: "4,000억",
          unit: "\u00A0원",
          second_value: "",
          second_unit: "",
        },
        use_tooltip: {
          title: false,
          value: false,
          second_value: false,
        },
        use_toggle: false,
        tooltip: {
          title: [],
          value: [],
          second_value: [],
        },
      },
      {
        data: {
          title: "총이익",
          value: "673.6억",
          unit: "\u00A0원",
          second_value: "",
          second_unit: "",
        },
      },
      {
        data: {
          title: "매각예상가",
          value: "4,600억",
          unit: "\u00A0원",
          second_value: "",
          second_unit: "",
        },
      },
      {
        data: {
          title: "수익률",
          value: "17.1",
          unit: "\u00A0%",
          second_value: "",
          second_unit: "",
        },
      },
    ],
  },
  style: "white",
  handleClick: () => {},
  force_use_tooltip: false,
};

const data = {
  valuation_header: {
    title: "서울시 강남구 강남로 1",
    sub_title: "강욱 빌딩",
    saved_name: "강남로 1, 210906-1",
  },
  cards: [
    {
      saved_name: "역삼동 101-1, 210906-1",
      content: sample_content_data,
    },
    {
      saved_name: "역삼동 101-1, 210906-1",
      content: sample_content_data,
    },
    {
      saved_name: "역삼동 101-1, 210906-1",
      content: sample_content_data,
    },
  ],
  footer: {
    data: [
      { title: "예상 사업 기간", value: "30", unit: "개월" },
      { title: "매각금액 가정", value: "5,424", unit: "억 원" },
      { title: "수익률", value: "4.34", unit: "%" },
    ],
  },
};

const _convertData = (each_formatted_data) => {
  return {
    id: each_formatted_data.id,
    title: each_formatted_data.title,
    value: each_formatted_data.value,
    unit: each_formatted_data.value_unit,
    type: each_formatted_data.value_type,
    second_value: each_formatted_data.base,
    second_unit: each_formatted_data.base_unit,
    second_type: each_formatted_data.base_type,
  };
};

const _convertBaseDataOnly = (each_formatted_data) => {
  return {
    id: each_formatted_data.id,
    title: each_formatted_data.title,
    value: each_formatted_data.base,
    unit: each_formatted_data.base_unit,
    type: each_formatted_data.base_type,
  };
};

const getFooterData = (formatted_data) => {
  const x = formatted_data.result;
  //   return {
  //     id: "result",
  //     data: [x.sell_price, x.return, x.roe, x.irr],
  //   };
  return [
    { data: _convertData(formatted_data.archi.floor_area) },
    { data: _convertData(formatted_data.rent.noi) },
    { data: _convertData(formatted_data.use.tic) },
    { data: _convertData(formatted_data.src.debt_interest) },
    { data: _convertData(x.sell_price) },
    { data: _convertData(x.return) },
    { data: _convertData(x.roe) },
    { data: _convertData(x.irr) },
  ];
};

const getOtherData = (formatted_data) => {
  const x = formatted_data.other;
  return [
    [{ data: _convertData(x.period_total) }, { data: _convertData(x.cap) }],
  ];
};

const getSrcData = (formatted_data) => {
  const x = formatted_data.src;
  return [
    [
      { data: _convertData(x.pf), use_toggle: true },
      { data: _convertData(x.tr_a), style: "detail" },
      { data: _convertData(x.tr_b), style: "detail" },
    ],
    [
      { data: _convertData(x.equity), use_toggle: true },
      { data: _convertData(x.pref_share), style: "detail" },
      { data: _convertData(x.common_share), style: "detail" },
    ],
  ];
};

const getUseData = (formatted_data) => {
  const x = formatted_data.use;
  return [
    [
      { data: _convertData(x.buy_total), use_toggle: true },
      { data: _convertData(x.buy_price), style: "detail" },
      { data: _convertData(x.buy_support), style: "detail" },
      { data: _convertData(x.buy_fee), style: "detail" },
      { data: _convertData(x.brok_fee), style: "detail" },
      { data: _convertData(x.const_tax), style: "detail" },
      { data: _convertData(x.am_pm_fee), style: "detail" },
      { data: _convertData(x.buy_reserve), style: "detail" },
    ],
    [
      { data: _convertData(x.const_total), use_toggle: true },
      { data: _convertData(x.const_price), style: "detail" },
      { data: _convertData(x.indr_const_price), style: "detail" },
    ],
    [
      { data: _convertData(x.fin_total), use_toggle: true },
      { data: _convertData(x.pf_interest), style: "detail" },
      { data: _convertData(x.other_fee), style: "detail" },
    ],
    [
      { data: _convertData(x.other_total), use_toggle: true },
      { data: _convertData(x.ti_rent_fee), style: "detail" },
      { data: _convertData(x.stable_reserve), style: "detail" },
    ],
  ];
};

const getRentData = (formatted_data) => {
  const x = formatted_data.rent;
  return {};
};

const getArchiData = (formatted_data) => {
  const x = formatted_data.archi;
  return [
    [
      { data: _convertBaseDataOnly(x.bcr) },
      { data: _convertBaseDataOnly(x.far) },
      { data: _convertBaseDataOnly(x.par) },
    ],
  ];
};

const getBaseData = (formatted_data, addr) => {
  const x = formatted_data.base;
  return [
    [
      {
        data: {
          title: "주소",
          value: addr,
          unit: "",
          second_value: "",
          second_unit: "",
        },
      },
      { data: _convertData(x.land_area) },
      { data: _convertData(x.use_area) },
      { data: _convertData(x.recent_trade) },
    ],
  ];
};

const wrapValuationComp = (input_data_old, addr) => {
  let input_data = { ...input_data_old };
  const base = getBaseData(input_data, addr);
  const archi = getArchiData(input_data);
  const rent = getRentData(input_data);
  const use = getUseData(input_data);
  const src = getSrcData(input_data);
  const other = getOtherData(input_data);
  const footer = getFooterData(input_data);
  return {
    data: {
      content: [...base, ...archi, ...use, ...src, ...other],
      footer: footer,
    },
    style: "white",
    handleClick: () => {},
    force_use_tooltip: false,
  };
};

export default wrapValuationComp;
